import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { StorageRootDto } from "../StorageRootDto";

export class EventDto extends StorageRootDto {

	public ServerGuid: string;
	public TenantGuid: string;
	public UserGuid: string;
	public ScopeGuid: string;
	public AgentGuid: string;
	public ClientAgentGuid: string;
	public SchedDiscGuid: string;
	public SchedDiscResultGuid: string;
	public Category: string;
	public Source: string;
	public Level: string;
	public Description: string;

	constructor() {
		super();

		this.ServerGuid = "";
		this.TenantGuid = "";
		this.UserGuid = "";
		this.ScopeGuid = "";
		this.AgentGuid = "";
		this.ClientAgentGuid = "";
		this.SchedDiscGuid = "";
		this.SchedDiscResultGuid = "";
		this.Category = "";
		this.Source = "";
		this.Level = "";
		this.Description = "";
	}

	public get HasServerGuid(): boolean {
		return !!this.ServerGuid;
	}

	public get HasTenantGuid(): boolean {
		return !!this.TenantGuid;
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasScopeGuid(): boolean {
		return !!this.ScopeGuid;
	}

	public get HasAgentGuid(): boolean {
		return !!this.AgentGuid;
	}

	public get HasClientAgentGuid(): boolean {
		return !!this.ClientAgentGuid;
	}

	public get HasSchedDiscGuid(): boolean {
		return !!this.SchedDiscGuid;
	}

	public get HasSchedDiscResultGuid(): boolean {
		return !!this.SchedDiscResultGuid;
	}

	public get HasCategory(): boolean {
		return !!this.Category;
	}

	public get HasSource(): boolean {
		return !!this.Source;
	}

	public get HasLevel(): boolean {
		return !!this.Level;
	}

	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public Write(obj: any, context: any): void {
		obj.event = {};
		obj = obj.event;

		super.Write(obj, context);

		if (this.HasServerGuid)
			obj.server_guid = this.ServerGuid;

		if (this.HasTenantGuid)
			obj.tenant_guid = this.TenantGuid;

		if (this.HasUserGuid)
			obj.user_guid = this.UserGuid;

		if (this.HasScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		if (this.HasAgentGuid)
			obj.agent_guid = this.AgentGuid;

		if (this.HasClientAgentGuid)
			obj.client_agent_guid = this.ClientAgentGuid;

		if (this.HasSchedDiscGuid)
			obj.sched_disc_guid = this.SchedDiscGuid;

		if (this.HasSchedDiscResultGuid)
			obj.sched_disc_result_guid = this.SchedDiscResultGuid;

		if (this.HasCategory)
			obj.category = this.Category;

		if (this.HasSource)
			obj.source = this.Source;

		if (this.HasLevel)
			obj.level = this.Level;

		if (this.HasDescription)
			obj.description = this.Description;
	}

	public Read(obj: any, context: any): void {

		if (!obj.event)
			throw new Error();
		obj = obj.event;

		super.Read(obj, context);

		if (obj.server_guid !== undefined)
			this.ServerGuid = obj.server_guid;

		if (obj.tenant_guid !== undefined)
			this.TenantGuid = obj.tenant_guid;

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.agent_guid !== undefined)
			this.AgentGuid = obj.agent_guid;

		if (obj.client_agent_guid !== undefined)
			this.ClientAgentGuid = obj.client_agent_guid;

		if (obj.sched_disc_guid !== undefined)
			this.SchedDiscGuid = obj.sched_disc_guid;

		if (obj.sched_disc_result_guid !== undefined)
			this.SchedDiscResultGuid = obj.sched_disc_result_guid;

		if (obj.category !== undefined)
			this.Category = obj.category;

		if (obj.source !== undefined)
			this.Source = obj.source;

		if (obj.level !== undefined)
			this.Level = obj.level;

		if (obj.description !== undefined)
			this.Description = obj.description;
	}

}